import Component from 'gia/Component';
import gsap from 'gsap';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.link = this.DOM.view.querySelector( '.uploaded-pdf > a' )
    //!
    this.VARS = {}
    this.VARS.WIDTH = '100%'
    this.VARS.HEIGHT = '700px'

    this.setup()

  }

  setup()
  {
    this.href = encodeURI( this.DOM.link.getAttribute( 'href' ) );
    if (typeof this.href != undefined && this.href != '' ) {
      this.widthValue = this.DOM.link.getAttribute( 'data-width' );
			this.heightValue = this.DOM.link.getAttribute( 'data-height' );

			if ( this.widthValue != '' && this.widthValue > 0 ) {
				this.VARS.WIDTH = this.widthValue + 'px';
			}
      if ( this.heightValue != '' && this.heightValue > 0 ) {
				this.VARS.HEIGHT = this.heightValue + 'px';
			}
      this.iframeTag = document.createElement('iframe')
      this.iframeTag.classList.add('pdfjs-viewer')
      this.iframeTag.setAttribute('src',`${config.pdfViewerUrl}?file=${this.href}`)
      gsap.set(this.iframeTag, { 'width':this.VARS.WIDTH, 'height':this.VARS.HEIGHT })
      this.ref.receptor[0].appendChild(this.iframeTag)
    }
  }

  unmount()
  {

  }
}
